/* ============
 * Public Profile
 * ============
 *
 * This is the page for editing the public profile.
 */
import { mapGetters } from 'vuex';
import Forms from './../../../../utils/forms/forms';
import publicProfileTransformer from './../../../../transformers/publicProfile';
import publicProfileService from './../../../../services/publicProfile';

export default {
  data() {
    return {
      form: new Forms({
        profileUrl: {
          value: '',
          type: 'text',
        },
        header: {
          value: '',
          type: 'text',
        },
        subheader: {
          value: '',
          type: 'text',
        },
        appointmentConfirmationTitle: {
          value: '',
          type: 'text',
        },
        appointmentConfirmationTemplate: {
          value: '',
          type: 'textarea',
        },
        defaultReminderTitle: {
          value: '',
          type: 'text',
        },
        defaultReminder: {
          value: '',
          type: 'textarea',
        },
        defaultCancelMessageTitle: {
          value: '',
          type: 'text',
        },
        defaultCancelMessage: {
          value: '',
          type: 'textarea',
        },
        backgroundImage: {
          value: '',
          type: 'file',
        },
      }),
      profileUrl: '',
      loading: false,
    };
  },

  computed: {
    ...mapGetters({
      publicProfile: 'publicProfile',
    }),
  },

  watch: {
    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} publicProfile    The publicProfile.
     */
    publicProfile(publicProfile) {
      this.form.assignData(publicProfile);
      this.updateProfileUrl(publicProfile);
    },
  },

  created() {
    this.form.setTooltip('defaultReminderTitle', this.$t('form.publicProfile.defaultReminder.tooltip'));
    this.form.setTooltip('defaultReminder', this.$t('form.publicProfile.defaultReminder.tooltip'));
    this.form.setTooltip('defaultCancelMessageTitle', this.$t('form.publicProfile.defaultCancelMessage.tooltip'));
    this.form.setTooltip('defaultCancelMessage', this.$t('form.publicProfile.defaultCancelMessage.tooltip'));
    this.form.setTooltip('appointmentConfirmationTitle', this.$t('form.publicProfile.appointmentConfirmationTemplate.tooltip'));
    this.form.setTooltip('appointmentConfirmationTemplate', this.$t('form.publicProfile.appointmentConfirmationTemplate.tooltip'));
    this.form.assignData(this.publicProfile);

    if (Object.keys(this.publicProfile).length === 0) {
      this.loading = true;
      publicProfileService.show()
      .then((profile) => {
        this.updateProfileUrl(profile);
        this.loading = false;
      });
    } else {
      this.updateProfileUrl(this.publicProfile);
    }
  },

  methods: {
    updateProfileUrl(profile) {
      if (profile.profileUrl.length > 0) {
        this.form.fields.profileUrl = 'hide';
        this.profileUrl = profile.profileUrl;
        this.$forceUpdate();
      }
    },

    /**
     * This method will be called when saving the form.
     */
    save() {
      this.form.loading = true;
      const publicProfile = publicProfileTransformer.send(this.form.data());
      publicProfileService.update(publicProfile)
      .then(() => {
        this.form.loading = false;
        this.form.successMessage = this.$t('static.publicProfile.updateSucess');
      })
      .catch((errors) => {
        this.form.loading = false;
        this.form.recordErrors(errors);
      });
    },
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
    VOpenHours: require('./../../../../components/openHours/openHours.vue'),
    VExceptionalHours: require('./../../../../components/exceptionalHours/exceptionalHours.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/profile/publicProfile/publicProfile.js